import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const MissionVision = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-[#fff9f8]  font-sans text-gray-800">
      {/* Vision & Mission Section */}
      <section className="py-8 px-6 md:px-20">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          {/* Vision */}
          <div
            className="bg-white border border-orange-200 rounded-2xl shadow-sm p-8 hover:shadow-md transition"
            data-aos="fade-right"
          >
            <h3 className="text-2xl font-semibold font-bricolage text-gray-900 mb-4">
              Our Vision
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed">
            To make mathematics accessible, engaging, and rewarding for every BTech student in Kerala.
            We strive to turn fear into confidence and confusion into clarity, helping students see maths not as a challenge, but as a skill to master and enjoy.
            </p>
          </div>

          {/* Mission */}
          <div
            className="bg-white border border-orange-200 rounded-2xl shadow-sm p-8 hover:shadow-md transition"
            data-aos="fade-left"
          >
            <h3 className="text-2xl font-semibold font-bricolage text-gray-900 mb-4">
              Our Mission
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed">
            Our mission is to turn challenges into confidence — guiding students who find mathematics tough to understand better, learn smarter, and score higher.
            Through our easy-to-follow lessons and practical approach, we make maths not just easier, but enjoyable and empowering.
            </p>
          </div>
        </div>
      </section>

      {/* ✅ YouTube Community Section */}
      <section className="relative py-24 bg-transparent overflow-hidden">
        {/* ✅ Background Circles (Fixed Visibility & Centered) */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="absolute w-[450px] h-[450px] rounded-full border border-[#F8B68B] opacity-50"></div>
          <div className="absolute w-[310px] h-[310px] rounded-full border border-[#F8B68B] opacity-50"></div>
          <div className="absolute w-[200px] h-[200px] rounded-full border border-[#F8B68B] opacity-50"></div>
        </div>

        {/* Text + Button */}
        <div
          className="relative z-10 text-center max-w-2xl mx-auto px-6 py-10 rounded-2xl"
          data-aos="zoom-in-up"
        >
          <h2 className="text-3xl font-bricolage md:text-4xl font-bold text-gray-900 mb-4">
            Join Our YouTube Community
          </h2>
          <p className="text-gray-600 text-lg mb-8">
          Subscribe to our YouTube channel for detailed lessons, tips, and insights to help you master BTech Mathematics.
          </p>
          <a
            href="https://www.youtube.com/@btechmathematics"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-[#3b82f6] hover:bg-[#2563eb] text-white font-semibold px-8 py-3 rounded-full transition-all">
              Subscribe
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default MissionVision;
